export default __webpack_public_path__ + "static/media/1787.c7caa8ef.png";